<template>
  <div class="standart-checkbox" :class="id">
    <input class="checkbox" type="checkbox" ref="checkbox">
    <div class="custom-checkbox" @click="toggleCheck()" :class="[{checked : checked}]">
      <svg v-show="checked" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M3.33337 8.66675L5.68432 10.5475C6.23587 10.9887 7.03581 10.9233 7.50831 10.3983L12.6667 4.66675" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="text_content" @click="toggleCheck()">
      <slot name="text_content"></slot>
    </div>
  </div>
  <div class="error-text" v-show="errorText != '' && errorText != null">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M8 1.5C4.41594 1.5 1.5 4.41594 1.5 8C1.5 11.5841 4.41594 14.5 8 14.5C11.5841 14.5 14.5 11.5841 14.5 8C14.5 4.41594 11.5841 1.5 8 1.5ZM8 11.4972C7.87639 11.4972 7.75555 11.4605 7.65277 11.3919C7.54999 11.3232 7.46988 11.2256 7.42258 11.1114C7.37527 10.9972 7.36289 10.8715 7.38701 10.7503C7.41112 10.629 7.47065 10.5177 7.55806 10.4302C7.64547 10.3428 7.75683 10.2833 7.87807 10.2592C7.99931 10.2351 8.12497 10.2475 8.23918 10.2948C8.35338 10.3421 8.45099 10.4222 8.51967 10.525C8.58834 10.6277 8.625 10.7486 8.625 10.8722C8.625 11.0379 8.55915 11.1969 8.44194 11.3141C8.32473 11.4313 8.16576 11.4972 8 11.4972ZM8.67875 5.21125L8.49938 9.02375C8.49938 9.15636 8.4467 9.28354 8.35293 9.3773C8.25916 9.47107 8.13198 9.52375 7.99937 9.52375C7.86677 9.52375 7.73959 9.47107 7.64582 9.3773C7.55205 9.28354 7.49937 9.15636 7.49937 9.02375L7.32 5.21313V5.21156C7.31607 5.11998 7.33071 5.02854 7.36305 4.94277C7.39539 4.85699 7.44475 4.77865 7.50817 4.71245C7.57158 4.64626 7.64774 4.59358 7.73205 4.55759C7.81636 4.5216 7.90708 4.50305 7.99875 4.50305C8.09042 4.50305 8.18114 4.5216 8.26545 4.55759C8.34976 4.59358 8.42592 4.64626 8.48933 4.71245C8.55275 4.77865 8.60211 4.85699 8.63445 4.94277C8.66679 5.02854 8.68143 5.11998 8.6775 5.21156L8.67875 5.21125Z" fill="#FA4B61"/>
    </svg>
    <span>{{errorText}}</span>
  </div>
</template>

<script>

export default {
  name : "StandartCheckbox",
  emits: ["change"],
  props : {
    id : String,
    checked : Boolean,
    errorText: String
  },
  data() {
    return{

    }
  },
  methods: {
    toggleCheck : function () {
      if(!this.checked) {
        this.$refs.checkbox.checked = true;
        this.$emit("change", true);
      } else {
        this.$refs.checkbox.checked = false;
        this.$emit("change", false);
      }
    }
  }
}
</script>

<style scoped>
.standart-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
}

.standart-checkbox input{
  display: none;
}

.standart-checkbox .custom-checkbox {
  border-radius: 4px;
  background: var(--Blue, #1B78BC);
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid var(--Border);
  background: var(--BG, #F8F8F8);
  box-sizing: border-box;
}

.standart-checkbox .custom-checkbox.checked {
  background: var(--Blue, #1B78BC);
  border: 1px solid var(--Blue, #1B78BC);
}

.standart-checkbox:hover .custom-checkbox {
  border: 1px solid var(--Blue, #1B78BC);
}

.text_content {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  flex: 1;
  cursor: pointer;
}

.error-text {
  display: flex;
  gap: 8px;
}

.error-text span{
  color: var(--Red, #FA4B61);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 136%;
  flex: 1;
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .standart-checkbox {
    align-items: start;
  }
}

</style>

<style>
.standart-checkbox .text_content a {
  color: var(--Blue, #1B78BC);
  text-decoration-line: underline;
}
</style>